export const getAttributes = (conversation) => {
    if (!conversation) {
        return {};
    }
    const { attributes } = conversation;
    let attrs = attributes;
    while (typeof attrs === "string") {
        attrs = JSON.parse(attributes);
    }
    return attrs;
};

// Example:
// Argument = "+18432557147"
// Returns = "+1 843 255 7147"
export const formatPhoneNumber = (unformattedPhoneNumber) => {
    const withoutPrefix = unformattedPhoneNumber.substring(unformattedPhoneNumber.length - 10, unformattedPhoneNumber.length);
    const firstPart = withoutPrefix.substring(0, 3);
    const secondPart = withoutPrefix.substring(3, 6);
    const thirdPart = withoutPrefix.substring(6, 10);
    return unformattedPhoneNumber.replace(withoutPrefix, ` ${firstPart} ${secondPart} ${thirdPart}`);
};
